exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!../../../scss/esferas.css"), "");

// module
exports.push([module.id, ".card-content-esf[data-v-64585186]{font-weight:600;color:#057d8d}.card-content-esf-tit[data-v-64585186]{font-weight:600;color:#54545c!important;font-size:14px}.card-header-title[data-v-64585186]{margin-bottom:0;font-size:20px;color:#54545c;font-weight:600;padding:.5rem}.card-header[data-v-64585186]{box-shadow:none}.card-content[data-v-64585186]{padding:.5rem}@media (min-width:320px) and (orientation:landscape){.card-content-esf[data-v-64585186]{font-weight:600;color:#057d8d}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64585186","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/estaciones_Componentes/layouts/card_Esfera.vue
// module id = 2779
// module chunks = 0